import AxiosClient from "../../../services/axios.services";

class EnrollmentCapacitacionServices {
  createCourse = (data) =>
    AxiosClient.post("/api/app/capacitacion_cursos_registrar/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editCourse = (id, data) =>
    AxiosClient.put(`/api/app/capacitacion_cursos_actualizar/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  cancelCourse = (id, data) =>
    AxiosClient.patch(`/api/app/capacitacion_curso_cancelar/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  getRegistered = (id) =>
    AxiosClient.get(`/api/app/capacitacion_curso_empleados_registros/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  getCourses = (params) =>
    AxiosClient.get("/api/app/capacitacion_cursos/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getCoursesEmployees = (params) =>
    AxiosClient.get("/api/app/capacitacion_cursos_empleados/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  newEnrollmentEmployee = (data) =>
    AxiosClient.post("/api/app/capacitacion_curso_empleado_matricula/", data, {
      headers: { "Content-Type": "application/json" },
    });
  getEnrolledEmployees = (id) =>
    AxiosClient.get(`/api/app/capacitacion_cursos_subordinados_jefe/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  postPassEnrollment = (data) =>
    AxiosClient.post(`/api/app/capacitacion_cursos_subordinados_jefe_aprobacion/`, data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new EnrollmentCapacitacionServices();
